import trackingService from 'config/trackingService';

const sendToTracking = <T>(data: T) => trackingService.post('tracking/tracking', data);

export default sendToTracking;
